import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';

import {
  DiscriminatedMatterInvestigationUpdatedEvent,
  ReadMatterInvestigation,
} from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  FieldsChanged,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterInvestigationUpdatedEventV2Props {
  event: DiscriminatedMatterInvestigationUpdatedEvent;
}

/**
 * V2 renderer for Matter Investigation Updated events that uses the `previous` field
 * to show only what changed. Very simple - just status and description fields.
 */
export const MatterInvestigationUpdatedEventV2: React.FC<
  MatterInvestigationUpdatedEventV2Props
> = ({ event }) => {
  const { investigation, previous } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100">
          <PencilIcon className="h-4 w-4 text-green-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <FieldsChanged<ReadMatterInvestigation>
        previous={previous}
        current={investigation}
        fieldsToCheck={['status', 'description']}
      />
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Investigation Updated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
